import { PwaTerminalGuard } from './guard/pwa-terminal.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// 以下追加したもの
import { UserLoginComponent } from './pages/user-login/user-login.component';
import { UserSignUpComponent } from './pages/user-signup/user-signup.component';
import { AuthGuard } from './guard/auth.guard';
import { OwnHistoriesComponent } from './pages/own-histories/own-histories.component';
import { ApproverGuard } from './guard/approver.guard';
import { RequestApproveComponent } from './pages/request-approve/request-approve.component';
import { PayrollReportComponent } from './pages/payroll-report/payroll-report.component';
import { TeamManageComponent } from './pages/team-manage/team-manage.component';
import { MaintenerGuard } from './guard/maintener.guard';
import { UserManageComponent } from './pages/user-manage/user-manage.component';
import { TerminalManageComponent } from './pages/terminal-manage/terminal-manage.component';
import { PasswordResetComponent } from './pages/password-reset/password-reset.component';
import { AdminGuard } from './guard/admin.guard';
import { ReportGuard } from './guard/report.guard';
import { FirstLoginGuard } from './guard/first-login.guard';
import { PersonalSettingsComponent } from './pages/personal-settings/personal-settings.component';
import { PunchStampComponent } from './pages/punch-stamp/punch-stamp.component';
import { TerminalLoginComponent } from './pages/terminal-login/terminal-login.component';
import { NavigationComponent } from './pages/navigation/navigation.component';
import { TerminalNavigationComponent } from './pages/terminal-navigation/terminal-navigation.component';
import { LoggedInGuard } from './guard/logged-in.guard';
import { TerminalAuthGuard } from './guard/terminal-auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: NavigationComponent,
    children: [
      { path: '', component: OwnHistoriesComponent, canActivate: [AuthGuard, FirstLoginGuard] },
      { path: 'history', component: OwnHistoriesComponent, canActivate: [AuthGuard, FirstLoginGuard] },
      { path: 'login', component: UserLoginComponent, canActivate: [LoggedInGuard] },
      // { path: 'change-request', component: ChangeRequestComponent, canActivate: [AuthGuard] },
      { path: 'approve', component: RequestApproveComponent, canActivate: [ApproverGuard] },
      { path: 'report', component: PayrollReportComponent, canActivate: [ReportGuard, FirstLoginGuard] },
      { path: 'team-manage', component: TeamManageComponent, canActivate: [MaintenerGuard, FirstLoginGuard] },
      { path: 'user-manage', component: UserManageComponent, canActivate: [MaintenerGuard, FirstLoginGuard] },
      { path: 'terminal-manage', component: TerminalManageComponent, canActivate: [AdminGuard, FirstLoginGuard] },
      { path: 'reset-password', component: PasswordResetComponent },
      { path: 'personal-settings', component: PersonalSettingsComponent, canActivate: [AuthGuard]},
      { path: 'signup', component: UserSignUpComponent },
    ]
  },
  { path: 'terminal', component: TerminalNavigationComponent,
    children: [
      { path: '', redirectTo: '/terminal/terminal-login', pathMatch: 'full' },
      { path: 'terminal-login', component: TerminalLoginComponent },
      { path: 'punch-stamp', component: PunchStampComponent , canActivate: [TerminalAuthGuard, PwaTerminalGuard] }
    ]
  },
  { path: '**', redirectTo: '/home' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
